import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import Button from './Button';
import EventForm from '../forms/Event';
import Modal from './Modal';
import { Icon } from '../icons';

import './createneweventbutton.scss';

import {
  toggleEventForm
} from '../../actions/events';

const CreateNewEventButton = ({ t, onEventModelToggle, eventModalOpen }) => (
  <div>
    {eventModalOpen && <Modal title={t('CREATE_NEW_EVENT')} onClose={onEventModelToggle}><EventForm /></Modal>}
    <Button className="btn-create-event" onClick={onEventModelToggle}>
      <Icon className="create-event-icon" type="plus" />
      <span className="create-event-text">{t('CREATE_NEW_EVENT')}</span>
    </Button>
  </div>
);

export default translate('events')(connect(
  ({ ui: { map: { eventModalOpen } } }) => ({
    eventModalOpen,
  }),
  { onEventModelToggle: toggleEventForm },
)(CreateNewEventButton));



// WEBPACK FOOTER //
// ./src/components/layout/CreateNewEventButton.js